import axios from 'axios';
import API from './API';


export const Accounts_Register = (data) => API.post('Accounts/Register', data);
export const Accounts_Verify = (data) => API.post('Accounts/Verify', data);
export const Accounts_Reverify = (data) => API.post('Accounts/Reverify', data);
export const Accounts_ResetPassword = (data) => API.post('Accounts/Reset_Password', data);
export const Accounts_ResetPassword_Verify = (data) => API.post('Accounts/Reset_Password_Verify', data);
export const Accounts_ResetPassword_Final = (data) => API.post('Accounts/Reset_Password_Final', data);
export const Accounts_Login = (data) => API.post('Accounts/Login', data);
export const Accounts_Profile = (data) => API.get('Accounts/Profile', data);
export const Accounts_GetByID = (id) => {
  const Token = localStorage.getItem("Token");
  return API.get(`Accounts/Get/${id}`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Accounts_GetByID_Basic = (id) => {
  const Token = localStorage.getItem("Token");
  return API.get(`Accounts/Get_Basic/${id}`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};
export const Accounts_GetAll = () => {
  const Token = localStorage.getItem("Token");
  return API.get("Accounts/GetAll", {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};
export const Accounts_Update = (Accounts_ID, Data) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Accounts/Update/${Accounts_ID}`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
}

export const Accounts_Approve = (Accounts_ID) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Accounts/Approve/${Accounts_ID}`, {}, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
}

export const Accounts_Reject = (Data) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Accounts/Reject`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
}

export const Accounts_Deactivate = (Accounts_ID) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Accounts/Deactivate/${Accounts_ID}`, {}, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
}

export const Accounts_Reinstate = (Accounts_ID) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Accounts/Reinstate/${Accounts_ID}`, {}, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
}

export const Accounts_Reactivate = (Accounts_ID) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Accounts/Reactivate/${Accounts_ID}`, {}, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
}

export const Accounts_Delete = (Accounts_ID) => {
  const Token = localStorage.getItem("Token");
  return API.delete(`Accounts/Delete/${Accounts_ID}`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
}

export const Accounts_Update_Password = (Data) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Accounts/Update_Password`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
}